import React from 'react'
const globalContext = React.createContext();
export default globalContext;